import { request } from '../../lib/request_product';
/**
 * 产品开启会员折扣
 * @param {*} data 
 * @returns 
 */
export function updateMemberDiscountSwitchByList(params,data) {
    return request({
        url: '{#npgw}/mwebapi/product/product/updateMemberDiscountSwitchByList',
        method: 'post',
        params,
        data,
    });
}
/**
 * 产品列表
 * @param {*}
 * @returns
 */
export function getList(data) {
    return request({
        url: '{#npgw}/mwebapi/product/product/findPage',
        method: 'post',
        data,
    });
}

/**
 * 线下订单添加产品 -产品列表
 * @param {*}
 * @returns
 */
export function findPageForOrder(data) {
    return request({
        url: '{#npgw}/mwebapi/product/product/findPageForOrder',
        method: 'post',
        data,
    });
}
/**
 * 分类列表
 * @param {*}
 * @returns
 */
export function getCateList(params) {
    return request({
        url: '{#npgw}/mwebapi/product/productCategory/getList',
        method: 'get',
        params,
    });
}
export function updateBasic(data) {
    return request({
        url: '{#npgw}/mwebapi/product/product/updateBasic',
        method: 'post',
        data,
    });
}
/**
 * 更新显示状态
 * @param {*}
 * @returns
 */
export function updateStatus(data, logObj) {
    return request({
        url: '{#npgw}/mwebapi/product/product/updateStatus',
        method: 'post',
        data,
        logObj,
        logFlag: {
            appName: '产品管理',
            //operModule: '显示或隐藏产品',
        },
    });
}
/**
 * 打标记
 * @param {*}
 * @returns
 */
export function updateMark(data) {
    return request({
        url: '{#npgw}/mwebapi/product/product/updateMark',
        method: 'post',
        data,
    });
}
/**
 * 转移分类
 * @param {*}
 * @returns
 */
export function updateCategory(data) {
    return request({
        url: '{#npgw}/mwebapi/product/product/updateCategory',
        method: 'post',
        data,
    });
}
/**
 * 选择橱窗
 * @param {*}
 * @returns
 */
export function updateShowcase(data) {
    return request({
        url: '{#npgw}/mwebapi/product/product/updateShowcase',
        method: 'post',
        data,
    });
}
/**
 * 置顶
 * @param {*}
 * @returns
 */
export function updateOnTop(data) {
    return request({
        url: '{#npgw}/mwebapi/product/product/updateOnTop',
        method: 'post',
        data,
    });
}
/**
 * 标记列表
 * @param {*}
 * @returns
 */
export function markList(params) {
    return request({
        url: '{#npgw}/mwebapi/product/productMark/getList',
        method: 'get',
        params,
    });
}
/**
 * 删除产品
 * @param {*}
 * @returns
 */
export function deleteByList(data, logObj) {
    return request({
        url: '{#npgw}/mwebapi/product/product/deleteByList',
        method: 'post',
        data,
        logObj,
        logFlag: {
            appName: '产品管理',
            operModule: '删除产品',
        },
    });
}
/**
 * 品牌列表
 * @param {*}
 * @returns
 */
export function brandList(params) {
    return request({
        url: '{#npgw}/mwebapi/product/productBrand/getList',
        method: 'get',
        params,
    });
}
/**
 * 获取关键词
 * @param {*}
 * @returns
 */
export function getKeywords(data) {
    return request({
        url: '{#npgw}/mwebapi/product/productCategory/getKeywords',
        method: 'post',
        data,
    });
}
/**
 * 查询产品详情
 * @param {*}
 * @returns
 */
export function getProductAndTemplate(params) {
    return request({
        url: '{#npgw}/mwebapi/product/product/getProductAndTemplate',
        method: 'get',
        params,
        timeout: 60000
    });
}
/**
 * 橱窗列表
 * @param {*}
 * @returns
 */
export function windowList(data) {
    return request({
        url: '{#npgw}/mwebapi/product/productShowcase/findPage',
        method: 'post',
        data,
    });
}
/**
 * 获取该条产品所在的橱窗
 * @param {*}
 * @returns
 */
export function getWindowByProId(params) {
    return request({
        url: '{#npgw}/mwebapi/product/productShowcase/findByProductId',
        method: 'get',
        params,
    });
}
/**
 * 获取该条产品所有的标记
 */
export function getMarkByProId(params) {
    return request({
        url: '{#npgw}/mwebapi/product/productMark/findByProductId',
        method: 'get',
        params,
    });
}
export function updateSequence(data) {
    return request({
        url: '{#npgw}/mwebapi/product/product/updateSequence',
        method: 'post',
        data,
    });
}
/**
 * 添加产品
 * @param {*}
 * @returns
 */
export function addProduct(data, params, logObj) {
    return request({
        url: '{#npgw}/mwebapi/product/product/add',
        method: 'post',
        data, 
        params,
        logObj,
        logFlag: {
            appName: '产品管理',
            operModule: '添加产品',
        },
        timeout: 60000
    });
}
/**
 * 编辑产品
 * @param {*}
 * @returns
 */
export function editProduct(data, params, logObj) {
    return request({
        url: '{#npgw}/mwebapi/product/product/edit',
        method: 'post',
        data, 
        params,
        logObj,
        logFlag: {
            appName: '产品管理',
            operModule: '编辑产品',
        },
        timeout: 60000
    });
}
/**
 * 获取草稿列表
 * @param {*}
 * @returns
 */
export function getDraftList(data) {
    return request({
        url: '{#npgw}/mwebapi/product/productDraft/findPage',
        method: 'post',
        data,
    });
}
/**
 * 编辑草稿
 * @param {*}
 * @returns
 */
export function editDraft(data) {
    return request({
        url: '{#npgw}/mwebapi/product/productDraft/edit',
        method: 'post',
        data,
        timeout: 60000
    });
}
/**
 * 添加草稿
 * @param {*}
 * @returns
 */
export function addDraft(data,params) {
    return request({
        url: '{#npgw}/mwebapi/product/productDraft/save',
        method: 'post',
        data,
        params,
        timeout: 60000
    });
}
/**
 * 删除草稿
 * @param {*}
 * @returns
 */
export function delDraft(data) {
    return request({
        url: '{#npgw}/mwebapi/product/productDraft/deleteByList',
        method: 'post',
        data,
    });
}
/**
 * 根据id获取分类名称
 * @param {*}
 * @returns
 */
export function getCateNameByIds(data) {
    return request({
        url: '{#npgw}/mwebapi/product/productCategory/getByIds',
        method: 'post',
        data,
    });
}
/**
 * code验重
 * @param {*}
 * @returns
 */
export function getUniqueStatusForCode(params) {
    return request({
        url: '{#npgw}/mwebapi/product/product/getUniqueStatusForCode',
        method: 'get',
        params,
    });
}
/**
 * 预览接口
 * @param {appId：2,productId:1}} params
 * @returns url
 */
export function getPreviewUrl(params) {
    return request({
        url: '{#npgw}/mwebapi/product/product/getPreviewUrl',
        method: 'get',
        params,
    });
}
/**
 * 存排序规则
 * keyword='productFrontSort'
 * content=4
 */
export function saveSort(data) {
    return request({
        url: '{#npgw}/pms/tenantRecord/saveOrUpdate',
        method: 'post',
        data,
    });
}

/**
 * 查排序规则
 * keyword='productFrontSort'
 *
 */
export function findSort(data) {
    return request({
        url: '{#npgw}/pms/tenantRecord/findListByTenantIdOrKeyWord',
        method: 'post',
        data,
    });
}

/**
 * 模糊查分类
 * name='aaa'
 *
 */
export function findCates(params) {
    return request({
        url: '{#npgw}/mwebapi/product/productCategory/findAll',
        method: 'get',
        params,
    });
}

/**
 * 获取skuList
 * name='aaa'
 *
 */
export function getSkuListByProductId(params) {
    return request({
        url: '{#npgw}/mwebapi/product/product/getSkuList',
        method: 'get',
        params,
    });
}
/**
 * 获取币种
 * name='aaa'
 *
 */
export function getSiteInfo(params) {
    return request({
        url: '{#npgw}/mwebapi/sysconfig/getForward/api/sysconfig/site/baseConfig/getSiteInfo',
        method: 'get',
        params,
    });
}
/**
 * 校验敏感词
 */
export function findContentContainWords(data) {
    return request({
        url: '{#npgw}/mwebapi/sysconfig/getForward/api/sysconfig/sensitive/findContentContainWords',
        method: 'post',
        data,
    });
}
/**
 * 上移，下移
 */
export function swapProductSort(params) {
    return request({
        url: '{#npgw}/mwebapi/product/product/swapProductSort',
        method: 'get',
        params,
    });
}
/**
 * 移到首位
 */
export function swapProductTop(params) {
    return request({
        url: '{#npgw}/mwebapi/product/product/swapProductTop',
        method: 'get',
        params,
    });
}

/**
 * 移到首位
 */
export function getSortFirstProduct(params) {
    return request({
        url: '{#npgw}/mwebapi/product/product/getSortFirstProduct',
        method: 'get',
        params,
    });
}
/**
 * 拖拽排序
 */
export function swapProducts(data) {
    return request({
        url: '{#npgw}/mwebapi/product/product/swapProducts',
        method: 'post',
        data,
    });
}

/**
 * 获取产品会员权限
 */
export function getDataPermissionByProductId(params) {
    return request({
        url: '{#npgw}/mwebapi/product/product/getDataPermissionByProductId',
        method: 'get',
        params,
    });
}
/**
 * 保存产品会员权限
 */
export function saveProductDataPermission(data) {
    return request({
        url: '{#npgw}/mwebapi/product/product/saveProductDataPermission',
        method: 'post',
        data,
    });
}

export function findVisits(data) {
    return request({
        url: '{#npgw}/fwebapi/visitor/counter/find',
        method: 'post',
        data,
    });
}
/**
 * 获取产品自定义url
 */
export function getCustomUrl(params) {
    return request({
        url: '{#npgw}/mwebapi/sysconfig/costomUrlRule/getCustomUrl',
        method: 'get',
        params,
    });
}
/**
 * 设置产品自定义url
 */
export function setCustomUrl(data) {
    return request({
        url: '{#npgw}/mwebapi/sysconfig/costomUrlRule/addCustomUrl',
        method: 'post',
        data,
    });
}

/**
 * 获取按照规则渲染的url-type true列表 false详情
 */
export function getCostomRuleRenderUrl(params, data) {
    return request({
        url: '{#npgw}/mwebapi/sysconfig/costomUrlRule/getCostomRuleRenderUrl',
        method: 'post',
        params,
        data
    });
}

//验重
export function checkCustomUrlExist(params) {
    return request({
        url: `{#npgw}/mwebapi/sysconfig/costomUrlRule/checkCustomUrlExist`,
        method: 'post',
        params,
    });
}
/**
 * 查询展示页面列表接口
 */
export function findShowPage(params) {
    return request({
        url: '{#npgw}/mwebapi/lowcode/page/findShowPage',
        method: 'get',
        params,
    });
}
/**
 * 设置展示页接口
 */
export function addAssignPage(params) {
    return request({
        url: '{#npgw}/mwebapi/lowcode/page/addAssignPage',
        method: 'post',
        params,
    });
}
/**
 * 查询已设置展示页接口
 */
export function getAssignPageId(params) {
    return request({
        url: '{#npgw}/mwebapi/lowcode/page/getAssignPageId',
        method: 'get',
        params,
    });
}
/**
 * 获取详情设计器
 */
export function getOldDesignUrl(params) {
    return request({
        url: '{#npgw}/mwebapi/product/product/getOldDesignUrl',
        method: 'get',
        params,
    });
}
/*获取应用列表*/
export function getAllTenantAppListByTenantId(data) {
    return request({
        url: '{#npgw}/pms/pcpTenantApp/getAllTenantAppListByTenantId',
        method: 'post',
        data,
    });
}

/*获取分享数据获取（url和二维码）*/
export function getShareInfo(data) {
    return request({
        url: '{#npgw}/api/qrcode/getQrCodeAndContentUrl',
        method: 'post',
        data,
    });
}
//获取推荐词
export function getInitLabelList(data) {
    return request({
        url: '{#npgw}/mwebapi/product/help/keywords',
        method: 'post',
        data,
    });
}
//产品名称验重
export function existProductName(data) {
    return request({
        url: '{#npgw}/mwebapi/product/product/existProductName',
        method: 'post',
        data,
    });
}
//产品字段列表
export function getTemplateFields(params) {
    return request({
        method: 'get',
        url: `{#npgw}/mwebapi/sysconfig/targetForward/mwebapi/product/productTemplate/getTemplateFields`,
        params,
    });
}
//根据语言code获取语言中文名
export function getLanguageByCode(params) {
    return request({
        method: 'get',
        url: `{#npgw}/mwebapi/sysconfig/translation/getLanguageByCode`,
        params
    })
}
//增量翻译
export function commit(data) {
    return request({
        url: '{#npgw}/mwebapi/translate/record/commit',
        method: 'post',
        data,
    });
}
//翻译语言列表
export function websiteList(params) {
    return request({
        url: '{#npgw}/mwebapi/sysconfig/translation/websiteList',
        method: 'get',
        params,
    });
}

//获取翻译语言
export function queryTranslateRecordById(params) {
    return request({
        url: '{#npgw}/mwebapi/translate/record/queryTranslateSuccessList',
        method: 'get',
        params,
    });
}

//增量翻译获取规则
export function judgeSwitch(data) {
    return request({
        url: '{#npgw}/mwebapi/sysconfig/translation/judgeSwitch',
        method: 'post',
        data,
    });
}

// 翻译标识
export function checkExecStateCount(params) {
    return request({
        url: '{#npgw}/mwebapi/translate/record/checkExecStateCount',
        method: 'get',
        params,
    });
}

// 获取二维码配置数据
export function getQrCodeSetting(params) {
    return request({
        url: '{#npgw}/mwebapi/product/productTemplate/getQrCodeSetting',
        method: 'get',
        params,
    });
}
//新增或编辑二维码配置数据
export function addUpdateQrCodeSetting(data) {
    return request({
        url: '{#npgw}/mwebapi/product/productTemplate/addUpdateQrCodeSetting',
        method: 'post',
        data,
    });
}
//获取产品数据的二维码地址
export function findQrCodeList(data) {
    return request({
        url: '{#npgw}/mwebapi/product/product/findQrCodeList',
        method: 'post',
        data,
    });
}
//根据模板Id获取单行文本字段
export function getTemplateTxtFields(params) {
    return request({
        url: '{#npgw}/mwebapi/product/productTemplate/getTemplateTxtFields',
        method: 'get',
        params,
    });
}
export function getRecordExistById(data) {
    return request({
        url: '{#npgw}/mwebapi/translate/record/getRecordExistById',
        method: 'post',
        data,
    });
}
export function getById(params) {
    return request({
        url: '{#npgw}/mwebapi/translate/record/getById',
        method: 'get',
        params,
    });
}

export function getProductFeatureWhitelist(params) {
    return request({
        url: '{#npgw}/mwebapi/product/productWhite/getProductFeatureWhitelist',
        method: 'get',
        params,
    });
}